import React from "react";
import logo from "@/assets/borehub-logo.png";

// BoreHub cutterhead mark (customer-supplied).
export default function CutterheadLogo({ size = 32 }) {
  return <img src={logo} width={size} height={size} alt="BoreHub" style={{ width: size, height: size, objectFit: "contain" }} />;
}
